/* eslint-disable no-nested-ternary */
// Dependencies
import React from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// hooks
import useContentDynamic from '../hooks/useContentDynamic';
import useLogin from '../hooks/useLogin';
import useLanguage from '../hooks/useLanguage';

// images
import dashboardBlack from '../../sass/images/icons/dashboard_black.svg';
import dashboardWhite from '../../sass/images/icons/dashboard_white.svg';
import schedulingBlack from '../../sass/images/icons/scheduling_icon_black.svg';
import schedulingWhite from '../../sass/images/icons/scheduling_icon_white.svg';
import requestMaintenanceBlack from '../../sass/images/icons/request-maintenance-black.svg';
import requestMaintenanceWhite from '../../sass/images/icons/request-maintenance-white.svg';
import downloadReportBlack from '../../sass/images/icons/download_report_black.svg';
import downloadReportWhite from '../../sass/images/icons/download_report_white.svg';
import requestVehicleRegisBlack from '../../sass/images/icons/history_blue.svg';
import requestVehicleRegisWhite from '../../sass/images/icons/history_white.svg';
import requestDriverRegisBlack from '../../sass/images/icons/request_driver_regis_black.svg';
import requestDriverRegisWhite from '../../sass/images/icons/request_driver_regis_white.svg';
import userBlack from '../../sass/images/icons/user_black.svg';
import userWhite from '../../sass/images/icons/user_white.svg';

import approveCancelBlack from '../../sass/images/icons/approve_cancel-black.svg';
import approveCancelWhite from '../../sass/images/icons/approve_cancel-white.svg';
import closeBlack from '../../sass/images/icons/icon_exit_black.svg';
import closeWhite from '../../sass/images/icons/icon_exit_white.svg';
import alertMenu from '../../sass/images/icons/alert-menu.svg';

function MenuContentCompany(props) {
  const { t, children, newMaintenances } = props;
  const { locale } = useLanguage();
  const { expandedMenu, location, history, selectedNav, setSelect, setExpanded } =
    useContentDynamic();
  const { rolId, logout } = useLogin({});

  return (
    <div className="col-12">
      <SideNav
        expanded={expandedMenu}
        onToggle={(expanded) => {
          setExpanded(expanded);
        }}
        onSelect={(selected) => {
          const to = `/${locale}/${selected}`;
          if (location.pathname !== to) {
            setSelect(selected);
            history.push(to);
          }
        }}
      >
        <SideNav.Toggle />
        <SideNav.Nav defaultSelected={selectedNav}>
          <NavItem eventKey={t('routers:CompanyDashboard')}>
            <NavIcon>
              <img
                className={newMaintenances > 0 ? 'icon' : ''}
                src={
                  selectedNav === `${t('routers:CompanyDashboard')}`
                    ? dashboardWhite
                    : dashboardBlack
                }
                alt={t('alt:dashboard')}
              />
              {newMaintenances > 0 ? (
                <img className="img-alert-menu" src={alertMenu} alt={t('alt:notification')} />
              ) : (
                ''
              )}
            </NavIcon>
            <NavText>Dashboard</NavText>
          </NavItem>
          <NavItem eventKey={t('routers:JobsAgenda')}>
            <NavIcon>
              <img
                className={newMaintenances > 0 ? 'icon' : ''}
                src={
                  selectedNav === `${t('routers:JobsAgenda')}` ? schedulingWhite : schedulingBlack
                }
                alt={t('alt:maintenance_schedule')}
              />
              {newMaintenances > 0 ? (
                <img className="img-alert-menu" src={alertMenu} alt={t('alt:notification')} />
              ) : (
                ''
              )}
            </NavIcon>
            <NavText>{t('jobsAgenda')}</NavText>
          </NavItem>
          <NavItem eventKey={t('routers:JobRequests')}>
            <NavIcon>
              <img
                src={
                  selectedNav === `${t('routers:JobRequests')}`
                    ? requestMaintenanceWhite
                    : requestMaintenanceBlack
                }
                alt={t('alt:request_maintenance')}
              />
            </NavIcon>
            <NavText>{t('jobRequests')}</NavText>
          </NavItem>
          <NavItem eventKey={t('routers:Report')}>
            <NavIcon>
              <img
                src={
                  selectedNav === `${t('routers:Report')}`
                    ? downloadReportWhite
                    : downloadReportBlack
                }
                alt={t('alt:download')}
              />
            </NavIcon>
            <NavText>{t('report')}</NavText>
          </NavItem>
          <NavItem eventKey={t('routers:VehiclesView')}>
            <NavIcon>
              <img
                src={
                  selectedNav === `${t('routers:VehiclesView')}`
                    ? requestVehicleRegisWhite
                    : requestVehicleRegisBlack
                }
                alt={t('alt:vehicle_registration')}
              />
            </NavIcon>
            <NavText>{t('vehicleView')}</NavText>
          </NavItem>
          <NavItem eventKey={t('routers:DriverRegistration')}>
            <NavIcon>
              <img
                src={
                  selectedNav === `${t('routers:DriverRegistration')}`
                    ? requestDriverRegisWhite
                    : requestDriverRegisBlack
                }
                alt={t('alt:driver_registration')}
              />
            </NavIcon>
            <NavText>{t('driverRegistration')}</NavText>
          </NavItem>
          {rolId === 3 || rolId === 9 ? (
            <NavItem eventKey={t('routers:UserRegistration')}>
              <NavIcon>
                <img
                  src={selectedNav === `${t('routers:UserRegistration')}` ? userWhite : userBlack}
                  alt={t('alt:user_registration')}
                />
              </NavIcon>
              <NavText>{t('userRegistration')}</NavText>
            </NavItem>
          ) : (
            ''
          )}
          <NavItem eventKey={t('routers:QualifyService')}>
            <NavIcon>
              <img
                src={
                  selectedNav === t('routers:QualifyService')
                    ? approveCancelWhite
                    : approveCancelBlack
                }
                alt={t('alt:approve_qualify_service')}
              />
            </NavIcon>
            <NavText>{t('qualifyService')}</NavText>
          </NavItem>
          <NavItem eventKey="" className="close_sesion_company" onClick={logout}>
            <NavIcon>
              <img src={selectedNav === '' ? closeWhite : closeBlack} alt={t('alt:logout')} />
            </NavIcon>
            <NavText>{t('logout')}</NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
      <div className={`content_dashboard ${expandedMenu ? 'show-content' : 'hide-content'}`}>
        {children}
      </div>
    </div>
  );
}

MenuContentCompany.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  newMaintenances: PropTypes.number,
};
MenuContentCompany.defaultProps = {
  newMaintenances: 0,
};

export default withTranslation(['privateMenu', 'routers', 'alt'])(MenuContentCompany);
